module.exports = __webpack_public_path__ + "img/LX.1303da00.webp";